import React from 'react';
import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

const params = page => ({ params: { page } });

export default function useGetWiresForSeries(slug) {
  const [state, q] = useAxios({
    url: `/api/v1/wires/series/${slug}`,
    method: 'GET',
    ...params(1),
  }, { manual: true });
  const executeQuery = React.useCallback(page => q(params(page)), [q]);
  return [state, executeQuery];
}
